/**
 * Cross-module auth event bus.
 *
 * The axios interceptor lives outside React, but it needs to push state
 * back into AuthContext when a session ends (refresh failed, RT revoked,
 * etc). We use a custom DOM event so AuthContext can subscribe without
 * importing the interceptor.
 */

export const AUTH_LOGOUT_EVENT = 'auth:logout';

export function emitAuthLogout(reason: string = 'session_expired'): void {
  window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT, { detail: { reason } }));
}
